import { provideHttpClient } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule, provideAnimations } from '@angular/platform-browser/animations';
import { AlertModule, BMDTreeModule, LoaderModule } from '@component';
import { CoreModule } from '@core';
import { BMDModule } from '@view';
import { AppComponent } from './app.component';

@NgModule({
  bootstrap: [AppComponent],
  declarations: [AppComponent],
  exports: [BrowserModule, BrowserAnimationsModule, CoreModule],
  imports: [
    AlertModule,
    BrowserModule,
    BrowserAnimationsModule,
    CoreModule,
    LoaderModule,
    MatSidenavModule,
    MatButtonModule,
    MatInputModule,
    MatIconModule,
    BMDModule,
    BMDTreeModule,
    MatSlideToggleModule,
    FormsModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatNativeDateModule,
    MatDialogModule,
  ],
  providers: [provideAnimations(), provideHttpClient()],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
